@if(isDisabled){
<app-loader></app-loader>
}
<form name="ClusterForm" (ngSubmit)="ClusterForm.form.valid && Save()" #ClusterForm="ngForm">
    <div class="card">
        <div class="card-header">
            Cluster Master
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Branch<span class="text-danger">*</span></label>
                    <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="Detail.BranchID" placeholder="Select Branch" required [disabled]="id > 0">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch.
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label>Code<span class="text-danger">*</span></label>
                    <input name="Code" maxlength="100" class="form-control" placeholder="Ex." [(ngModel)]="Detail.Code"
                        #Code="ngModel" required disabled>
                    <div class="invalid-feedback">
                        Please enter Code.
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label>Name<span class="text-danger">*</span></label>
                    <input name="clustername" maxlength="200" class="form-control" placeholder="Ex."
                        [(ngModel)]="Detail.ClusterName" #clustername="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter Name.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary me-1" (click)="close()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>

                        <button
                            *ngIf="(this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)"
                            type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>